import React, { useEffect, useState } from "react";
import { XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, AreaChart, Area } from 'recharts';
import { API_URL } from "../../../actions/settings";
import LoadingSpinner from "../../extras/LoadingSpinner";
import { formatGraphData, formatYearlyGraphData } from "../../extras/Functions";
import { IonToggle } from "@ionic/react";
import useToggle from "../../../utils/useToggle";


interface Props {
  id: string;
}

const formatValue = (value:number)=> {
    const formatter = new Intl.NumberFormat('en-US',{notation:'compact',maximumFractionDigits: 1 })
    return '$'+formatter.format(value)
  }


async function getCostAvoidanceData(token: string, id: string) {
  return fetch(`${API_URL}/graphs/total_cost_avoidance/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: token,
    },
  }).then((res) => {
    if (res.ok) {
      return res.json();
    } else {
      return false;
    }});
}


const CustomTick = ({x,y,payload}:any)=>{
    return <g transform={`translate(${x},${y})`}>
    <text x={0} y={0} dy={16} textAnchor="end" fill="white" transform="rotate(-35)">
      {payload.value}
    </text>
  </g>
}

const CostAvoidanceGraph: React.FC<Props> = ({ id }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState<any>(null);
  const [yearlyData, setYearlyData] = useState<any>(null);
  const [yearly,toggleYearly] = useToggle(false)
  const [solar, setSolar] = useState(false)

  useEffect(() => {
    const handleData = async () => {
      const token = `Token ${(localStorage.getItem("token") || "").slice(1,-1)}`;
      const res = await getCostAvoidanceData(token, id);
      if(res) {
        setSolar(res.data.solar)
        delete res.data.solar
        setData(formatGraphData(res.data))
        if (res.data.dates.length > 23){
          toggleYearly()
        }
      } else setData(null)
      if(res) {setYearlyData(formatYearlyGraphData(res.data,'years',['yearly_savings','yearly_solar_savings']))} else setYearlyData(null)
      setLoading(false);
    };
    handleData();
  }, [id,toggleYearly]);

  const CustomTooltip = ({ active, payload }:any)=>{
    return <div style={{background:'white',border:'black solid 2px', padding:'5px'}}>
          {payload.map((entry:any, index:any) => {
                return (<div key={index}>
                  <div style={{color:'black'}}>
                    {entry.name ==='solar_savings' || entry.name ==='yearly_solar_savings'? null : yearly? entry.payload.year : entry.payload.dates } 
                    </div>
                  <div style={{color:'black'}} >
                    {entry.name ==='solar_savings' || entry.name ==='yearly_solar_savings'? 'Solar:' : 'Savings:'} {formatValue(entry.value)}                
                  </div>
                </div>)

          }
            
          )}
    </div>
  }


  return (
    <div>
      {loading ? (
        <LoadingSpinner />
      ) : !data ? (
        <div style={{height:'300px'}} className="center-all">
          <div style={{ width: "100%", textAlign: "center", fontSize: "larger" }}>
            No Score Data Available
          </div>
        </div>
      ) : (
        <div>
          <div style={{display:'flex',marginLeft:'3rem'}}>
            <div>Monthly</div>
            <IonToggle style={{marginLeft:'0.5em',marginRight:'0.5em'}} checked={yearly} onIonChange={()=>toggleYearly()}></IonToggle>
            <div>Yearly</div>
          </div>
        <ResponsiveContainer width="100%" height={450}>
          
        <AreaChart
          width={500}
          height={400}
          data={yearly? yearlyData : data}
          margin={{
            top: 5,
            right: 0,
            left: 0,
            bottom: 30,
          }}
        >
          <CartesianGrid strokeDasharray="10 10" />
          <XAxis tick={CustomTick} axisLine={false} dataKey={yearly?"year":"dates"} />
          <YAxis tickFormatter={formatValue} tick={{fill:'white'}} axisLine={false}/>
          <Tooltip content={CustomTooltip}/>
          {/* <Legend /> */}
          <Area type="monotone" dataKey={yearly?"yearly_savings":"savings"} strokeWidth={3} stroke="#01e8ff" fill="#01e8ff"/>
          {solar? 
          <Area type="monotone" dataKey={yearly?"yearly_solar_savings":"solar_savings"} strokeWidth={3} stroke="#FFA500" fill="#FFA500" /> : ''}
        </AreaChart>
       </ResponsiveContainer>
       </div>
      )}
    </div>
  );
};

export default CostAvoidanceGraph;
